
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-pin",
      function () {
        return require("private-next-pages/topic-pin/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-pin"])
      });
    }
  